import React from 'react';
import './land-details.css';
import Guests from "../guests/guests";

class LandDetails extends React.Component {

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.showGuests = this.props.showGuests;
        this.showItineraryLink = this.props.showItineraryLink;
    }

    render = () => {
        return (
            <div className="land-details">
                <div class="rea-landContainer rea-block-row">
                    <div className="rea-block-12">
                        <div className="rea-sectionHeaders">Trip Details</div>
                    </div>
                    <div className="rea-block-8">
                        <div className="rea-block-row">
                            <div className="rea-block-12 rea-bold">
                                {this.booking.itineraryDescription}
                            </div>
                            {this.showItineraryLink && this.booking.itineraryLinkUrl &&
                            <div className="rea-block-12">
                                <a href={this.booking.itineraryLinkUrl} target="_blank" rel="noopener noreferrer" className="rea-textLink">
                                    <i className="fa fa-map-marker"></i> View Itinerary
                                </a>
                            </div>
                            }
                            {
                                !this.booking.group &&
                                <div className="rea-block-12 rea-landDetails">
                                    <div className="rea-block-12 rea-padding-0">
                                        <div className="rea-sumLabel">
                                            Order Number:
                                        </div>
                                        <div className="rea-sumResult">
                                            {this.booking.bookingId}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className="rea-block-12">
                                <div className="rea-block-12 rea-padding-0">
                                    <div className="rea-sumLabel">
                                        Travel Dates:
                                    </div>
                                    <div className="rea-sumResult">
                                        {new Intl.DateTimeFormat('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: '2-digit'
                                        }).format(new Date(this.booking.tripStartDate))} - {new Intl.DateTimeFormat('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: '2-digit'
                                    }).format(new Date(this.booking.tripEndDate))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rea-block-4">
                        <div className="rea-detailsImg">
                            <div className="rea-shipImg rea-landImg">
                                <img src={this.booking.productImageUrl} width="200" alt="Product"/>
                            </div>
                        </div>
                    </div>
                </div>
                {this.showGuests &&
                <Guests guests={this.booking.guests}/>
                }
            </div>
        );
    }
}

export default LandDetails;
